import { graphql } from 'gatsby';
import React from 'react';
import IconBlurbsSlider from './icon-blurbs-slider';
import IconButtonsSlider from './icon-buttons-slider';
import MediaShowcaseSlider from './media-showcase-slider';
import TestimonialsSlider from './testimonials-slider';
import TimelineSlider from './timeline-slider';

// TODO: Remove Blogroll Slider from Contentstack and from fragment - clearly not used anymore, don't even know where the component is

const Slider: React.FC<Queries.SliderDataFragment> = (data) => {
    const { variants } = data || [];
    const sliderData = variants;

    if (!sliderData) return null;
    if (!sliderData[0]) return null;

    // eslint-disable-next-line no-underscore-dangle
    const typeName = sliderData[0].__typename;

    if (typeName === 'CsIconBlurbsGroup') {
        return <IconBlurbsSlider {...sliderData[0]} />;
    }

    if (typeName === 'CsIconButtonsGroup') {
        return <IconButtonsSlider {...sliderData[0]} />;
    }

    if (typeName === 'CsMediaShowcaseGroup') {
        return <MediaShowcaseSlider {...sliderData[0]} />;
    }

    if (typeName === 'CsTestimonialsGroup') {
        return <TestimonialsSlider {...sliderData[0]} />;
    }

    if (typeName === 'CsTimelineGroup') {
        return <TimelineSlider {...sliderData[0]} />;
    }

    return null;
};

export const query = graphql`
  fragment SliderData on CsSlider {
    ... on CsSlider {
      variants {
        __typename
        ... on CsBlogrollGroup {
          heading
          articles {
            title
            content
            url
            featuredImage {
              filename
              title
              description
              url
              contentStackAsset(width: 400)
            }
          }
        }
        ...IconBlurbsSliderData
        ...IconButtonsSliderData
        ...MediaShowcaseSliderData
        ...TestimonialsSliderData
        ...TimelineSliderData
      }
    }
  }
`;

export default Slider;
